<template>
  <!-- 计费 -->
  <div class="create-order">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="top"
      class="rule-content"
    >
      <titleBlock class="title_bar" title="计费设置">
        <div class="text-wrapper">
          <span class="text1">计费校验</span>
          <span class="text2">开启后订单开启计费，关闭后将跳过计费</span>
        </div>
        <el-switch
          v-model="form.PRICING_CHECK.flag"
          class="marginBottom"
          active-color="#059E84"
          inactive-color="#D9DBDE"
        />
        <addCondition
          v-if="form.PRICING_CHECK.flag"
          ref="AddCondition"
          class="Receiving"
          :condition-list.sync="form.PRICING_CONDITION.condition"
          validate-string="PRICING_CONDITION.condition"
          type="billing"
          :tips="form.PRICING_CHECK.flag?'BMS计费,不满足条件就跳过计费':'跳过计费,不满足条件就BMS计费'"
          :condition-type="conditionType"
          :condition-kind="CONDITION_KIND"
          @addOrCondition="addOrCondition"
          @addAdnCondition="addAdnCondition"
          @delete="Delete"
          @orDelete="handleOrDelete"
          @clearValidate="clearValidate"
        />
        <detailsView
          label="计费限额"
          :process-name="parentProcessName"
          :process-code="parentProcessCode"
          path="wwwwww"
          :field="detailField.BILL_QUOTA"
          :form="form"
        />
      </titleBlock>
      <titleBlock
        v-if="isExistWhite"
        class="title_bar"
        title="计费策略"
        alert-info="订单下单未匹配到唯一计费条款,将通过计费策略匹配条款"
      >
        <tactics
          :list.sync="form.PRICE_STRATEGY.datas"
          validate-string="PRICE_STRATEGY.datas"
          :customers-detail="customersDetail"
          @addTactics="addTactics"
          @addTacticsProject="addTacticsProject"
          @deleteTacticsProject="deleteTacticsProject"
        />
      </titleBlock>
      <titleBlock title="超时处理">
        <div class="flex align-center marginBottom">
          <el-switch
            v-model="form.PRICING_OVER_TIME.flag"
            active-color="#059E84"
            inactive-color="#D9DBDE"
          />
          <span class="switch_tips">开启时流程到达节点超时触发后将自动取消，关闭后不会自动取消。</span>
        </div>
        <div v-if="form.PRICING_OVER_TIME.flag" class="new-flex">
          <div class="second-title required">
            流程到达该节点
          </div>
          <el-form-item
            class="overTime_trigger"
            prop="PRICING_OVER_TIME_CONDITION.fieldName"
          >
            <div class="receiving_time flex align-center">
              <div class="flex align-center">
                <el-select
                  v-model="form.PRICING_OVER_TIME_CONDITION.fieldName"
                  placeholder="请选择"
                  class="receivingTimeType"
                >
                  <el-option
                    v-for="item in receivingTimeType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-select v-model="form.PRICING_OVER_TIME_CONDITION.action" class="receivingTimeTypeUnit">
                  <el-option
                    v-for="item in receivingStsgeType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="PRICING_OVER_TIME_CONDITION.num">
            <div class="time_input flex align-center">
              <el-input v-model="form.PRICING_OVER_TIME_CONDITION.num" placeholder="请输入" />
              <el-select v-model="form.PRICING_OVER_TIME_CONDITION.unit">
                <el-option
                  v-for="item in timeUnit"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <span v-if="form.overTimeTrigger!==OVERTIME_TYPE.BASIS_TABLE_FIELD" class="basis">后</span>
            </div>
          </el-form-item>
        </div>
      </titleBlock>
    </el-form>
  </div>
</template>

<script>
import { processingSelectData } from '@/utils/index';
import { getProjectList } from '@/api/user';
import titleBlock from '../assembly/titleBlock.vue';
import {
  timeReg, reg,
  OVERTIME_TYPE,
  TIME_UNIT,
  RECEIVING_TIME_TYPE,
  RECEIVING_STSGE_TYPE,
  CONDITION_TYPE_MAP,
  CONDITION_KIND,
  detailField,
  StarObjectList,
} from './const';
import addCondition from './addCondition.vue';
import detailsView from './detailsView.vue';
import tactics from './tactics.vue';
import { getConfigList } from '../api';

export default {
  components: {
    titleBlock, addCondition, detailsView, tactics,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    parentProcessName: {
      type: String,
      default: '',
    },
    parentProcessCode: {
      type: String,
      default: '',
    },
    customersDetail: {
      type: Object,
      default: () => {},
    },
    isExistWhite: {
      type: Boolean,
      default: false,
    },
    customerCode: {
      type: String,
      default: null,
    },
  },
  data() {
    const validateRange = (rule, value, callback) => {
      const { lower, upper } = value;
      const max = 999999;
      if (!reg.test(Number(lower)) || !reg.test(Number(upper)) || Number(lower) >= Number(upper)) {
        callback('请输入正确的范围');
      } else if (Number(lower) > max || Number(upper) > max) {
        callback('请输入正确的范围');
      }
      callback();
    };
    const validateTime = (rule, value, callback) => {
      if (!timeReg.test(Number(value))) {
        callback('请输入正确的时间');
      }
      callback();
    };
    return {
      OVERTIME_TYPE,
      CONDITION_KIND,
      detailField,
      module: 'PRICING',
      rules: {
        'PRICING_CHECK.flag': [
          { required: true, message: '请选择计费设置', trigger: 'change' },
        ],
        'PRICING_OVER_TIME_CONDITION.fieldName': [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        'PRICING_OVER_TIME_CONDITION.num': [
          { required: true, validator: validateTime, trigger: 'change' },
        ],
        PRICING_QUOTA: [
          { required: true, validator: validateRange, trigger: 'change' },
        ],
      },
      projectOptions: [],
      StarList: [],
      StarObjectList,
      // TODO:
      // chooseProjectIds: [], // 选择的运营项目
    };
  },
  computed: {
    timeUnit() {
      return processingSelectData(TIME_UNIT);
    },
    receivingTimeType() {
      return processingSelectData(RECEIVING_TIME_TYPE);
    },
    receivingStsgeType() {
      return processingSelectData(RECEIVING_STSGE_TYPE);
    },
    conditionType() {
      return processingSelectData(CONDITION_TYPE_MAP);
    },
  },
  watch: {
    // 'form.PRICING_CHECK.flag': {
    //   handler(flag) {
    //     if (flag && !this.form.PRICING_CONDITION.condition.length) {
    //       this.addOrCondition();
    //     }
    //   },
    //   immediate: true,
    // },

    // TODO:
    // 'form.STAR_CONTROL.rules': {
    //   handler(val) {
    //     if (!val || !val.length) {
    //       this.chooseProjectIds = [];
    //       return;
    //     }
    //     this.chooseProjectIds = val.map((t) => t.projectId);
    //   },
    //   immediate: true,
    // },

    customerCode: {
      handler(val) {
        if (val) {
          this.getProjectListFn();
        }
      },
      immediate: true,
    },
  },
  async created() {
    const res = await getConfigList({ keys: 'oms.star.conf', appId: '1004' });
    this.StarList = JSON.parse(res.configs?.[0].value || '[]');
  },
  methods: {
    async getProjectListFn() {
      const data = await getProjectList({
        customerCodes: [this.customerCode],
        status: 'ENABLE',
      });
      this.projectOptions = data.length > 0 ? data.map((t) => ({
        label: t.projectName,
        value: t.id,
      })) : [];
    },
    // TODO:
    // handleAddStar() {
    //   const list = this.form.STAR_CONTROL?.rules || [];
    //   list.push({ starType: 'CAR' });
    //   this.$set(this.form.STAR_CONTROL, 'rules', list);
    // },
    // TODO:
    // handleDeleteStar(index) {
    //   const list = this.form.STAR_CONTROL.rules;
    //   list.splice(index, 1);
    //   this.$set(this.form.STAR_CONTROL, 'rules', list);
    // },
    // TODO:
    // changeProject(val, index) {
    //   const tt = this.form.STAR_CONTROL.rules[index];
    //   const proItem = this.projectOptions.find((t) => t.value === val);
    //   this.form.STAR_CONTROL.rules.splice(index, 1, {
    //     ...tt,
    //     projectName: proItem.label,
    //   });
    // },
    async valiForm() {
      await this.$refs.form.validate();
      let data = Object.keys(JSON.parse(JSON.stringify(this.form)));
      if (!this.form.PRICING_OVER_TIME.flag) {
        data = data.filter((item) => item !== 'PRICING_OVER_TIME_CONDITION');
      }
      const res = [];
      data.forEach((item) => {
        if (item === 'PRICE_STRATEGY') {
          if (this.form[item].datas.length) {
            res.push({ ruleCode: item, ruleValue: { customerCode: this.customersDetail.customerCode, datas: this.filterData(this.form[item]) } });
          }
        } else {
          res.push({ ruleCode: item, ruleValue: this.form[item] });
        }
      });
      return {
        res,
        form: this.form,
      };
    },
    filterData(data) {
      const res = data.datas.map((item) => ({ ...item, projectReqs: item.projectReqs && item.projectReqs.length ? item.projectReqs.filter((pro) => pro.projectId) : [] }));
      return res;
    },
    clearValidate(prop) {
      this.$refs.form.clearValidate(prop);
    },
    addOrCondition() {
      this.$emit('addOrCondition', this.module, 'PRICING_CONDITION');
    },
    addAdnCondition(index) {
      this.$emit('addAdnCondition', index, this.module, 'PRICING_CONDITION');
    },
    Delete(value) {
      this.$emit('delete', value, this.module, 'PRICING_CONDITION');
    },
    handleOrDelete(value) {
      this.$emit('OrDelete', value, this.module, 'PRICING_CONDITION');
    },
    addTactics() {
      this.$emit('addTactics', this.module, 'PRICE_STRATEGY');
    },
    addTacticsProject(index, prop) {
      this.$emit('addTacticsProject', { index, prop }, this.module, 'PRICE_STRATEGY');
    },
    deleteTacticsProject(index, childIndex, prop) {
      this.$emit('deleteTacticsProject', { index, childIndex, prop }, this.module, 'PRICE_STRATEGY');
    },
  },
};
</script>

<style lang="scss" scoped>
.create-order{
  box-sizing: border-box;
  padding:0 24px 24px;
  padding-bottom: 40px;
  ::v-deep .title_bar{
    border-bottom: 1px solid #D9DBDE;
  }
  .title-block{
    padding-top:24px;
  }
  .text-wrapper{
    display:flex;
    align-items: center;
    .text1{
      font-size: 14px;
      color:#404B5C;
    }
    .text2{
      font-size: 13px;
      color:#808792;
      margin-left:8px;
    }
    .tip {
      margin-bottom: 24px;
    }
  }
  .new-flex{
    display:flex;
    flex-wrap:wrap;
    .second-title{
      color:#404B5C;
      margin-bottom:8px;
      width:100%;
    }
    ::v-deep .el-form-item{
      margin-right:16px;
      .el-select{
        margin-right:8px;
      }
      .el-input{
        margin-right:8px;
      }
    }
  }
  .required:before{
    content:'*';
    color:red;
  }
}
.rule_input{
  .el-input{
    width: 180px;
  }
  .rule_sign{
    margin: 0 16px;
  }
}
.addOrCondition_btn{
  cursor: pointer;
  height: 38px;
  border: 1px dashed #B3B7BE;
  font-size: 14px;
  margin-bottom: 24px;
  .el-icon-plus{
    margin-right: 10px;
  }
  &:hover{
    border-color: #51CDA6;
    color: #51CDA6;
  }
  &:focus{
    border-color: #059366;
    color: #059366;
  }
}
.danger{
  color:red;
  position: relative;
  top:30px;
}
.el-select{
  width: 100%;
}
.marginBottom{
  margin:8px 0 24px;
}
.switch_tips{
  margin-left:12px;
  font-size: 13px;
  color:#808792;
}
</style>
